// Snap a date string to the Monday of its week (ISO Mon=1)
export function snapToMonday(dateStr) {
  const d = new Date(dateStr);
  const day = d.getDay(); // 0=Sun, 1=Mon…6=Sat
  const offset = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + offset);
  return d.toISOString().split('T')[0];
}

// Snap a date string to the Sunday of its week
export function snapToSunday(dateStr) {
  const d = new Date(dateStr);
  const day = d.getDay();
  const offset = day === 0 ? 0 : 7 - day;
  d.setDate(d.getDate() + offset);
  return d.toISOString().split('T')[0];
}

const PHASE_COLORS = {
  base:    'rgb(var(--color-primary-500))', // blue
  build:   'rgb(var(--color-warning-500))', // orange
  peak:    'rgb(var(--color-danger-500))', // red
  taper:   'rgb(var(--color-accent-purple-500))', // purple
  race:    'rgb(var(--color-success-500))', // green
};
const PHASE_COLOR_DEFAULT = 'rgb(var(--color-neutral-500))';

const MILESTONE_ICONS = {
  ftp_test:        '⚡',
  race_simulation: '🧱',
  taper_start:     '📉',
  race:            '🏆',
  key_workout:     '🎯',
  rest_week:       '😴',
};
const MILESTONE_ICON_DEFAULT = '📌';

export function phaseColorFor(type) {
  return PHASE_COLORS[(type || '').toLowerCase()] || PHASE_COLOR_DEFAULT;
}

export function milestoneIconFor(type) {
  return MILESTONE_ICONS[(type || '').toLowerCase()] || MILESTONE_ICON_DEFAULT;
}

// Add display fields (color/icon) and snap dates. Used when applying
// add_phase, modify_phase, and add_milestone coach-actions proposals
// so the TrainingPlanPage renders them with the same affordances as
// phases loaded from storage.
export function decoratePhase(phase) {
  if (!phase) return phase;
  return {
    ...phase,
    startDate: phase.startDate ? snapToMonday(phase.startDate) : phase.startDate,
    endDate:   phase.endDate   ? snapToSunday(phase.endDate)   : phase.endDate,
    color:     phaseColorFor(phase.type),
  };
}

export function decorateMilestone(m) {
  if (!m) return m;
  return { ...m, icon: milestoneIconFor(m.type) };
}

// Required-field validators. Used by the load-time sanitizer to drop
// junk entries that would otherwise render as blank cards.
const isValidPhase     = p => p && p.id && typeof p.name === 'string' && p.name.trim() && p.startDate && p.endDate;
const isValidMilestone = m => m && m.id && m.date && (m.label || m.type || m.name);

/**
 * Drop phases and milestones that lack the minimum required fields.
 * Use on data loaded from localStorage to self-heal previously-corrupted
 * plans (e.g. wiped by a buggy AI emit before the parser was hardened).
 */
export function sanitizeTrainingPlan(plan) {
  if (!plan) return { phases: [], milestones: [] };
  return {
    phases:     (plan.phases     || []).filter(isValidPhase),
    milestones: (plan.milestones || []).filter(isValidMilestone),
  };
}
